// extracted by mini-css-extract-plugin
export var alt = "ProfileIntro-module--alt--b2c0d";
export var desktopOnly = "ProfileIntro-module--desktopOnly--96de1";
export var greeting = "ProfileIntro-module--greeting--90278";
export var main = "ProfileIntro-module--main--6ae67";
export var memberNumber = "ProfileIntro-module--memberNumber--4003e";
export var mobileOnly = "ProfileIntro-module--mobileOnly--dc15f";
export var textLeft = "ProfileIntro-module--textLeft--94aa0";
export var title5 = "ProfileIntro-module--title5--b9a8f";
export var visuallyHidden = "ProfileIntro-module--visuallyHidden--499ac";